export default __webpack_public_path__ + "static/media/us-hwy-wide.1ba75aa7.svg";